"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../Box"));
var _Heading = _interopRequireDefault(require("../Heading"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TotallySureBadge = /*#__PURE__*/(0, _react.forwardRef)(function BadgeComponent(_ref, ref) {
  var text = _ref.text,
    ariaDescribedby = _ref.ariaDescribedby;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    px: "space10",
    backgroundColor: "eligibilityLevel0-100",
    borderRadius: "borderRadius05",
    alignSelf: "baseline",
    display: "inline-flex",
    "aria-describedby": ariaDescribedby,
    alignItems: "center",
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    variant: "10",
    color: "white"
  }, text));
});
var _default = exports["default"] = TotallySureBadge;